import * as yup from "yup";

// const PASSWORD_REGEX = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/

const loginValidationSchema = yup.object().shape({
  email: yup
    .string()
    .email("Enter a valid email address.")
    .required("Enter your email address."),

  password: yup.string().required("Enter your password."),
  // .matches(
  //     PASSWORD_REGEX,
  //     "Password must Contain at least 8 Characters(1 Uppercase, 1 Lowercase, 1 Number and 1 special case Character)"
  //   ),
});

export default loginValidationSchema;
